<div class="dialog-overlay">
  <div class="dialog-box">
    <h1 mat-dialog-title>Requirements URL</h1>

    <div
      style="place-content: end"
      mat-dialog-actions
    >
      <button
        class="close"
        mat-button
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div mat-dialog-content>
      <mat-form-field
        appearance="outline"
        [floatLabel]="'auto'"
      >
        <input
          matInput
          [value]="text"
          disabled
        />
      </mat-form-field>

      <button
        class="go-to"
        mat-button
        (click)="goToUrl()"
      >
        <mat-icon>launch</mat-icon>
      </button>

      <button
        class="copy"
        mat-button
        (click)="handleCopy()"
      >
        <mat-icon>file_copy</mat-icon>
      </button>
    </div>
  </div>
</div>
